<template>
<div class="popup" v-cloak v-if="cancelShow">
    <div class="content" id="cancelSub">
        <div class="title">
            <span v-if="isUser">{{$t('language.popup.subAccountPopup.cancel.titleUser')}}</span>
            <span v-else>{{$t('language.popup.subAccountPopup.cancel.titleItem')}}</span>
            <div class="icon white-close dialog-close" @click="closePage()"></div>
        </div>
        <div class="cancel-all-content">
            <span v-if="isUser">{{$t('language.popup.subAccountPopup.cancel.msgUser')}}</span>
            <span v-else>{{$t('language.popup.subAccountPopup.cancel.msgItem')}}</span>
        </div>
        <div class="cancel-all-footer">
            <div class="cancel-all-footer-left" >
                <button v-if="!loading" @click="cancelSub()"><span>{{$t('language.common.ok')}}</span></button>
                <button v-if="loading" v-loading='loading'></button>
            </div>
            <div class="cancel-all-footer-right" >
                <button @click="cancelShow=false"><span>{{$t('language.common.cancel')}}</span></button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            user: commonstate.user,
            cancelShow: false,
            cancelType: "",
            delItem: {},
            loading: false,
            isUser: false,
        }
    },
    methods: {
        //关闭弹窗
        closePage() {
            this.cancelType = "";
            this.delItem = {};
            this.loading = false;
            this.cancelShow = false;
            this.cancelType = "";
            this.isUser = false;
        },
        //删除操作
        cancelSub() {
            if(this.loading){return;}
            this.loading = true;
            if("ignore" == this.cancelType){               
                //删除项目或子账号
                if(this.delItem.subAccount&&this.delItem.subAccount.id&&this.delItem.subAccount.status==2){
                    //删除主子账号关系
                    this.delSubAccount();
                }else{
                    this.delPermission(this.delItem.delId);
                }
            }else{
                //删除权限
                this.delPermission(this.delItem.id);
            }
        },
        //解除关系
        delSubAccount(){
            this.Utils.doSubAccountRequest("del", {ud: this.user.id,subId:this.delItem.subAccount.id,uid:this.user.id}).then(res => {
                if(res.status=="200"){
                    //解除关系成功后删除权限
                    //this.delPermission(this.delItem.delId);
                    //关联删除，可控制子账号删除关系会删除账号，删除账号会关联删除权限
                    this.$parent.getPermissionList();//刷新权限列表
                    this.closePage();
                }else if(res.message){
                    this.$toast({
                        text: res.message,
                        type: 'fail',
                        idValue: "cancelSub"
                    });       
                }else{
                    this.loading = false;
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "cancelSub"
                    });
                }
            })
        },
        //删除权限
        delPermission(delId){
            let data = {
                ud: this.user.id,
                id:delId,
            }
            //判断是删除权限还是删除空项目或空子账号
            if(this.cancelType){
                data.type = this.cancelType;
            }
            this.Utils.doPermissionRequest("del_permission", data).then(res => {
                this.loading = false;
                if(res.status=="200"){
                    this.$parent.getPermissionList();//刷新权限列表
                    this.closePage();
                }else{
                    this.$toast({
                        text: this.$t('language.exception.' + res.reason),
                        type: 'fail',
                        idValue: "cancelSub"
                    });
                }
            })
        }
    }
}
</script>

<style>
#cancelSub {
    width: 400px;
    /*no*/
    height: 180px;
    /*no*/
}

.cancel-all-content {
    width: 100%;
    /*no*/
    height: 90px;
    /*no*/
    font-size: 14px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
    line-height: 20px;/*no*/
    padding-top: 35px;/*no*/
    text-align: center;
}

.cancel-all-footer {
    width: 100%;
    height: 48px;
    /*no*/
    box-sizing: border-box;
    padding: 0 20px 0 20px;
    /*no*/
}

#cancelSub .cancel-all-footer button {
    width: 65%;
}

#cancelSub .cancel-all-footer-left{
    float:left;
    width: 45%;
}

#cancelSub .cancel-all-footer-left button{
    float: right;
}

#cancelSub .cancel-all-footer-right{
    float:right;
    width: 45%;
}

#cancelSub .cancel-all-footer-right button{
    border: 1px solid #7080C6;
    background-color: #FFFFFF;
    color: #7080C6;
}

#cancelSub .el-loading-spinner .path {
    stroke: #fff !important;
}

#cancelSub .el-loading-spinner {
    position: relative;
    top: 4px;
    /*no*/
    margin-top: 0;
}

#cancelSub .el-loading-spinner i {
    color: #fff;
}

#cancelSub .el-loading-spinner {
    font-size: 15px;
    /*no*/
}

#cancelSub .el-loading-spinner .circular{
    width: 22px;/*no*/
    height: 22px;/*no*/
}
#cancelSub .el-loading-mask {
    background-color: #5166bd;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/sub_account_popups/cancel_popup.vue